import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const cMKeywordsApi = createApi({
  reducerPath: 'cMKeywordsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['CampaignKeywords'],
  endpoints: (builder) => ({
    getCampaignKeywords: builder.query({
      query: (params) => ({
        url: `/campaigns/campaign-keywords/`,
        params,
      }),
      providesTags: ['CampaignKeywords'],
    }),
    createCampaignKeyword: builder.mutation({
      query: (body) => ({
        url: '/campaigns/campaign-keywords/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CampaignKeywords'],
    }),
    getCampaignKeywordById: builder.query({
      query: (id) => ({
        url: `/campaigns/campaign-keywords/${id}`,
        method: 'GET',
      }),
      providesTags: ['CampaignKeywords'],
    }),
    updateCampaignKeyword: builder.mutation({
      query: ({ id, body }) => ({
        url: `/campaigns/campaign-keywords/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['CampaignKeywords'],
    }),
    
  }),
});

export const {
  useGetCampaignKeywordsQuery,
  useLazyGetCampaignKeywordsQuery,
  useGetCampaignKeywordByIdQuery,
  useCreateCampaignKeywordMutation,
  useUpdateCampaignKeywordMutation,
} = cMKeywordsApi;
